var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaximeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41 25",
    style: {
      enableBackground: "new 0 0 41 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:#5ACBC7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "meter2",
    transform: "translate(148.141 0.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_901",
    transform: "translate(-102.141 6.859)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25.4,
    y: 1.1,
    fill: "current",
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -34.4,
    y: 5.1,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -14.222 -22.16)",
    fill: "current",
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -37.9,
    y: 12.6,
    fill: "current",
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -14.9,
    y: 12.6,
    fill: "current",
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17.9,
    y: 5.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.2382 -10.1359)",
    fill: "current",
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_2001_1_",
    className: "st1",
    d: "M-21.3,9.5c0,0-6,3.4-6.7,3.9c-0.7,0.7-0.6,1.8,0.1,2.5c0,0,0.1,0.1,0.1,0.1 c0.8,0.8,2.4,0.8,2.8,0.2l1.1-2L-21.3,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M-26.1,17.1c-0.7,0-1.5-0.3-2-0.8c0,0-0.1-0.1-0.1-0.1c-0.4-0.4-0.7-1-0.7-1.6c0-0.6,0.2-1.2,0.6-1.6 c0.7-0.6,6.2-3.7,6.8-4l1.5-0.9l-4.6,8.2c-0.2,0.4-0.6,0.6-1.2,0.7C-25.8,17.1-26,17.1-26.1,17.1z M-22.6,10.8 c-2.2,1.3-4.7,2.7-5.1,3c-0.2,0.2-0.3,0.5-0.3,0.9c0,0.3,0.2,0.6,0.4,0.9l0.1,0.1c0.4,0.4,1.1,0.6,1.6,0.5c0.2,0,0.4-0.1,0.4-0.2 L-22.6,10.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M-143,24.4c-0.3-1.3-0.5-2.6-0.5-4c0-8.8,7.2-16,16-16s16,7.2,16,16c0,1.4-0.2,2.7-0.5,4h1 c0.3-1.3,0.5-2.6,0.5-4c0-9.4-7.6-17-17-17s-17,7.6-17,17c0,1.4,0.2,2.7,0.5,4H-143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M-138.8,24.4c-0.4-1.3-0.7-2.6-0.7-4c0-6.6,5.4-12,12-12c6.6,0,12,5.4,12,12c0,1.4-0.3,2.7-0.7,4h1.1 c0.4-1.3,0.6-2.6,0.6-4c0-7.2-5.8-13-13-13c-7.2,0-13,5.8-13,13c0,1.4,0.2,2.7,0.6,4H-138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M-146.1,24.4c-0.3-1.3-0.4-2.6-0.4-4c0-10.5,8.5-19,19-19s19,8.5,19,19c0,1.4-0.2,2.7-0.4,4h1 c0.3-1.3,0.4-2.6,0.4-4c0-11-9-20-20-20c-11,0-20,9-20,20c0,1.4,0.1,2.7,0.4,4H-146.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaximeter);
export default __webpack_public_path__ + "static/media/taximeter.6b2e79432f13a57b8dacef2e0389499a.svg";
export { ForwardRef as ReactComponent };